import { useContext } from 'react';
import { LanguageContext } from '../context/Locale';

export default function useLocale() {
  const context = useContext(LanguageContext);
  if (context === undefined) {
    throw new Error('useLocale must be used within a LanguageProvider');
  }
  return context;
}
